import { createIcon } from '../icon'
import HomeIcon from '../svg/HomeIcon'

export const HomeIconDefault = createIcon(HomeIcon)
